import * as React from "react";
const SvgSortUpIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 4, viewBox: "0 0 8 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 4L4 0.000121721L0 4L8 4Z", fill: "#004D48" }));
export default SvgSortUpIcon;
